import React from 'react';
import { Hero } from '../components/Hero';
import { Highlights } from '../components/Highlights';
import ProductShowcase from '../components/ProductShowcase';
import { WholesaleCta } from '../components/WholesaleCta';

export default function HomePage() {
  return (
    <>
      <Hero />
      <Highlights />
      <ProductShowcase />
      <WholesaleCta />
    </>
  );
}
